import { Reveal } from "@/lib/reveal";
import morrisonWater from "@/assets/morrison-water.jpg";
import mayaGrass from "@/assets/maya-grass.jpg";

export function FilmPrelude() {
  return (
    <section
      aria-label="Prelude to the film At Last"
      data-testid="film-prelude"
      className="relative"
    >
      <Reveal>
        <img
          src={morrisonWater}
          alt="Maya, a character in The Inkwell's film At Last, standing in dark water beneath a storm-blue sky, with the words 'You are your best thing. — Toni Morrison'"
          loading="lazy"
          width={681}
          height={701}
          data-testid="prelude-morrison-image"
          className="mx-auto h-auto w-full max-w-2xl"
        />
      </Reveal>

      <Reveal>
        <div
          data-testid="prelude-work-blurb"
          className="bg-[#d9d8d4] px-6 py-20 text-center sm:px-8 sm:py-28"
        >
          <div className="mx-auto max-w-3xl">
            <h2 className="font-serif text-4xl font-light tracking-tight text-[#26251f] sm:text-5xl">
              The Work
            </h2>
            <div className="mt-10 space-y-6 font-serif text-base leading-relaxed text-[#3a382f] sm:text-lg">
              <p>
                There are parts of a life we carry long after the moment has
                passed.
              </p>
              <p>
                We inherit things. We survive things. And sometimes, somewhere
                along the way, we become strangers to ourselves.
              </p>
              <p>
                Therapy is a place to look closely at what you have been
                carrying—and decide what is still yours to carry.
              </p>
              <p>
                You do not have to erase the past to live differently inside
                your own body, inside your own life.
              </p>
              <p className="italic">
                Sometimes the work is not changing the story. It is recognizing
                that a story you have carried for years no longer belongs to
                you.
              </p>
            </div>
            <p className="mt-10 font-serif text-sm tracking-[0.3em] text-[#4a483e]">
              — April Cook Suravallop
            </p>
          </div>
        </div>
      </Reveal>

      <Reveal>
        <img
          src={mayaGrass}
          alt="Maya, a character in The Inkwell's film At Last, seated in a field of silver grass before billowing blue smoke — a Kodak Portra film frame"
          loading="lazy"
          width={1122}
          height={491}
          data-testid="prelude-grass-image"
          className="h-auto w-full"
        />
      </Reveal>
    </section>
  );
}
